import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <CommentsSection />
        <IndexSection />
        <MediaSection />
        <CarouselSection />
        <FaqSection />
        <AboutSection />
        <FeaturesSection />
        <TopicsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}